var $34605f3e0266a8f3$exports = {};
$34605f3e0266a8f3$exports = {
    "decrease": (args)=>`Reducer ${args.fieldLabel}`,
    "increase": (args)=>`\xd8g ${args.fieldLabel}`,
    "numberField": `Talfelt`
};


export {$34605f3e0266a8f3$exports as default};
//# sourceMappingURL=da-DK.mjs.map
